import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import type { FunctionComponent } from 'react';
import { TitleByParts } from '../../../components/TitleByParts/TitleByParts';

export const PropertyTitleWithData: FunctionComponent = () => {
  const cachedQuery = usePropertyPageQuery();
  const header = cachedQuery?.data.propertyPageBySlugV3.header;

  if (!header?.pageTitleByPart) return null;

  const { part1, part2 } = header.pageTitleByPart;

  return <TitleByParts part1={part1} part2={part2} />;
};
